import { formatUnderscoreToSpace } from "../../utils/text-format";

const RadioView = ({ label, value = false, checkPosition = "left" }) => {
  return (
    <div className="my-4 flex items-center gap-2">
      {checkPosition === "left" && <input type="radio" checked={value} />}
      <label className="text-sm font-semibold text-gray-800 capitalize">
        {formatUnderscoreToSpace(label)}
      </label>
      {checkPosition === "right" && <input type="radio" checked={value} />}
    </div>
  );
};

export default RadioView;
